import ConsumerMailboxOptions from 'owa-service/lib/contract/ConsumerMailboxOptions';
import OptionsResponseBase from 'owa-service/lib/contract/OptionsResponseBase';
import SetConsumerMailboxRequest from 'owa-service/lib/contract/SetConsumerMailboxRequest';
import setConsumerMailboxOperation from 'owa-service/lib/operation/setConsumerMailboxOperation';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';

function createRequestBody(options: ConsumerMailboxOptions): SetConsumerMailboxRequest {
    let request: SetConsumerMailboxRequest = {
        Header: getJsonRequestHeader(),
        Options: options,
    };

    return request;
}

export default function setConsumerMailboxOptions(
    options: ConsumerMailboxOptions
): Promise<OptionsResponseBase> {
    let requestBody = createRequestBody(options);
    return setConsumerMailboxOperation(requestBody);
}
